import _ from 'lodash';
import {
  FETCH_FLEET_RESERVATIONS,
  GET_FLEET_RESERVATION,
  CHECK_FLEET_RESERVATION_AVAILABILITY,
  CREATE_FLEET_RESERVATION,
  RESCHEDULE_FLEET_RESERVATION,
  CANCEL_FLEET_RESERVATION,
} from 'actions/fleetReservation';
import { asArray, unwrap, normalizeListRow, normalizeDetail } from 'view/fleetReservations/fleetReservationUtils';

const initialState = {
  isLoading: false,
  isDetailLoading: false,
  isAvailabilityLoading: false,
  isSaving: false,
  results: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 0,
  detail: null,
};

const fleetReservationReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_FLEET_RESERVATIONS.REQUEST:
      return { ...state, isLoading: true };
    case FETCH_FLEET_RESERVATIONS.SUCCESS: {
      const data = unwrap(payload);
      return {
        ...state,
        isLoading: false,
        results: asArray(data).map(normalizeListRow),
        page: _.get(data, 'page', 1),
        limit: _.get(data, 'limit', 10),
        totalPages: _.get(data, 'totalPages', 1),
        total: _.get(data, 'totalResults', 0),
      };
    }
    case FETCH_FLEET_RESERVATIONS.FAIL:
      return { ...state, isLoading: false };

    case GET_FLEET_RESERVATION.REQUEST:
      return { ...state, isDetailLoading: true };
    case GET_FLEET_RESERVATION.SUCCESS:
      return { ...state, isDetailLoading: false, detail: normalizeDetail(unwrap(payload)) };
    case GET_FLEET_RESERVATION.FAIL:
      return { ...state, isDetailLoading: false, detail: null };

    case CHECK_FLEET_RESERVATION_AVAILABILITY.REQUEST:
      return { ...state, isAvailabilityLoading: true };
    case CHECK_FLEET_RESERVATION_AVAILABILITY.SUCCESS:
    case CHECK_FLEET_RESERVATION_AVAILABILITY.FAIL:
      return { ...state, isAvailabilityLoading: false };

    case CREATE_FLEET_RESERVATION.REQUEST:
    case RESCHEDULE_FLEET_RESERVATION.REQUEST:
    case CANCEL_FLEET_RESERVATION.REQUEST:
      return { ...state, isSaving: true };
    case CREATE_FLEET_RESERVATION.SUCCESS:
    case CREATE_FLEET_RESERVATION.FAIL:
    case RESCHEDULE_FLEET_RESERVATION.SUCCESS:
    case RESCHEDULE_FLEET_RESERVATION.FAIL:
    case CANCEL_FLEET_RESERVATION.SUCCESS:
    case CANCEL_FLEET_RESERVATION.FAIL:
      return { ...state, isSaving: false };

    default:
      return state;
  }
};

export default fleetReservationReducer;
